var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPage
    ? _c(
        "div",
        { staticClass: "yxt-biz yxtbiz-attachment-list" },
        [
          _c(
            "ul",
            { staticClass: "mr-16 layout-flex layout-flex-wrap" },
            _vm._l(_vm.showFiles, function (file) {
              return _c(
                "li",
                {
                  key: file.fileId || file.uuid,
                  staticClass: "mt16 mb8 mr16",
                  style: { width: _vm.attachmentItemWidth },
                },
                [
                  _c("Attachment", {
                    attrs: {
                      "image-height": _vm.attachmentItemHeight,
                      "show-delete": _vm.isEdit,
                      file: file,
                      "file-status-hidden": _vm.fileStatusHidden,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete", file)
                      },
                      preview: function ($event) {
                        return _vm.handlePreview(file)
                      },
                      download: function ($event) {
                        return _vm.handleDownload(file)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _vm.showLimit > -1 && _vm.files.length > _vm.showLimit && !_vm.isEdit
            ? _c("OpenCloseAll", {
                staticClass: "mb8",
                attrs: { open: _vm.open },
                on: {
                  "update:open": function ($event) {
                    _vm.open = $event
                  },
                },
              })
            : _vm._e(),
          _c("yxtbiz-course-player", {
            attrs: {
              "download-cb": function (fileId) {
                return _vm.handleDownload({ fileId: fileId })
              },
              visible: _vm.showCoursePlayer,
              "file-id-list": _vm.fileIdList,
              start: _vm.coursePlayerStart,
              "join-kng": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showCoursePlayer = $event
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }